import { render, staticRenderFns } from "./thousands.vue?vue&type=template&id=76f7bbf4&scoped=true"
import script from "./thousands.vue?vue&type=script&lang=js"
export * from "./thousands.vue?vue&type=script&lang=js"
import style0 from "./thousands.vue?vue&type=style&index=0&id=76f7bbf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f7bbf4",
  null
  
)

export default component.exports